import React, { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'antd'
import { getConvenienceCharge, getFlightDetails } from '../../../services/flight/flightServices'
import BookingFlightTripJack from './BookingFlightTripJack'
import BookingFilterTripjack from './BookingFilterTripjack'
import FlightNotFetch from '../bookingpagestbo/FlightNotFetch'
import FareAlertModal from './FareAlertModal'

const BookingDetailsTripJack = ({ location }) => {

    const [flightDetails, setflightDetails] = useState([]);
    const [loading, setLoading] = useState(null)
    const [messageData, setMessageData] = useState("");
    const [isModalOpenFlightNotFetch, setIsModalOpenFlightNotFetch] = useState(null);
    const [priceIds, setPriceIds] = useState(null);
    const bookingFilterRef = useRef();

    useEffect(() => {
        let selectedCards = location?.state?.selectedCards;
        let selectedCardReturn = location?.state?.selectedCardReturn;
        let flightDetailsId = location?.state?.itemId;
        let payload;

        if (location?.state && location?.state?.itemId) {
            payload = {
                priceIds: [flightDetailsId]
            };
        } else {
            payload = {
                priceIds: [selectedCards, selectedCardReturn]
            };
        }

        setLoading(true);
        setPriceIds(payload);
        getFlightDetails(payload)
            .then((resp) => {
                setflightDetails(resp.data);
                setIsModalOpenFlightNotFetch(false)
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
            })
            .catch((error) => {
                setLoading(false);
                console.error("errrr", error?.response?.data?.message);
                setMessageData(error?.response?.data?.message);
                setIsModalOpenFlightNotFetch(true)
            });
    }, [location]);


    const [selectedBaggages, setSelectedBaggages] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedMeals, setSelectedMeals] = useState([]);
    const [mealTotalAmount, setMealTotalAmount] = useState(0);

    const [totalSeatPrice, setTotalSeatPrice] = useState(null);
    const [selectedSeats, setSelectedSeats] = useState({});
    const [seatsList, setSeatsList] = useState(null);

    const [totalSeatsPriceReturn, setTotalSeatPriceReturn] = useState(null);
    const [selectedSeatsReturn, setSelectedSeatsReturn] = useState({});
    const [seatsListReturn, setSeatsListReturn] = useState(null);
    const [selectedMealsReturn, setSelectedMealsReturn] = useState([]);
    const [mealTotalAmountRetrun, setMealTotalAmountReturn] = useState(0);
    const totalSelectMeals = (flightDetails?.searchQuery?.paxInfo?.ADULT || 0) + (flightDetails?.searchQuery?.paxInfo?.CHILD || 0);
    const [selectedBaggagesReturn, setSelectedBaggagesReturn] = useState([]);
    const [totalAmountBaggageReturn, setTotalAmountBaggageReturn] = useState(0);

    const addMeal = (flightIndex, mealIndex, amount, meal, flightInfo) => {
        setSelectedMeals(prev => {
            const updated = [...prev];

            if (!updated[flightIndex]) {
                updated[flightIndex] = {
                    selectedMeals: [],
                    totalAmount: 0,
                    origin: flightInfo?.da?.cityCode,
                    destination: flightInfo?.aa?.cityCode
                };
            }

            if (updated[flightIndex].selectedMeals.length < totalSelectMeals) {
                updated[flightIndex].selectedMeals.push({
                    mealIndex,
                    meal,
                    code: meal.code,
                    price: meal.amount,
                    description: meal.desc
                });
                updated[flightIndex].totalAmount += amount;
                setMealTotalAmount(prev => prev + amount);
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return updated;
        });
    };


    const removeMeal = (flightIndex, mealIndex, amount) => {
        setSelectedMeals(prev => {
            const updated = [...prev];

            if (updated[flightIndex]) {
                const mealPos = updated[flightIndex].selectedMeals.findIndex(
                    m => m.mealIndex === mealIndex
                );

                if (mealPos !== -1) {
                    const removedMeal = updated[flightIndex].selectedMeals[mealPos];
                    updated[flightIndex].selectedMeals.splice(mealPos, 1);
                    updated[flightIndex].totalAmount -= removedMeal?.price || 0;
                    setMealTotalAmount(prev => Math.max(0, prev - (removedMeal?.price || 0)));
                }
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return updated;
        });
    };


    const addMealReturn = (flightIndex, mealIndex, amount, meal, flightInfo) => {
        setSelectedMealsReturn(prev => {
            const updated = [...prev];

            if (!updated[flightIndex]) {
                updated[flightIndex] = {
                    selectedMealsReturn: [],
                    totalAmount: 0,
                    origin: flightInfo?.da?.cityCode,
                    destination: flightInfo?.aa?.cityCode
                };
            }

            if (updated[flightIndex].selectedMealsReturn.length < totalSelectMeals) {
                updated[flightIndex].selectedMealsReturn.push({
                    mealIndex,
                    meal,
                    code: meal.code,
                    price: meal.amount,
                    description: meal.desc
                });
                updated[flightIndex].totalAmount += amount;
                setMealTotalAmountReturn(prev => prev + amount);
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return updated;
        });
    };

    const removeMealReturn = (flightIndex, mealIndex, amount) => {
        setSelectedMealsReturn(prev => {
            const updated = [...prev];

            if (updated[flightIndex]) {
                const mealPos = updated[flightIndex].selectedMealsReturn.findIndex(
                    m => m.mealIndex === mealIndex
                );

                if (mealPos !== -1) {
                    const removedMeal = updated[flightIndex].selectedMealsReturn[mealPos];
                    updated[flightIndex].selectedMealsReturn.splice(mealPos, 1);
                    updated[flightIndex].totalAmount -= removedMeal?.price || 0;
                    setMealTotalAmountReturn(prev => Math.max(0, prev - (removedMeal?.price || 0)));
                }
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            if (bookingFilterRef.current) {
                bookingFilterRef.current.handleRemoveCode();
            }
            return updated;
        });
    };

    const addBaggage = (baggage, flightInfo) => {
        const segments = flightInfo?.[0]?.sI;

        if (selectedBaggages.length < totalSelectMeals) {
            const newItem = {
                origin: segments?.[0]?.da?.code,
                destination: segments?.[0]?.aa?.code,
                code: baggage.code,
                price: baggage.amount,
                description: baggage.desc,
            };

            setSelectedBaggages(prev => [...prev, newItem]);
            setTotalAmount(prev => prev + baggage.amount);
        }
        if (bookingFilterRef.current) {
            bookingFilterRef.current.handleRemoveCode();
        }
    };

    const removeBaggage = (baggage, flightInfo) => {
        const segments = flightInfo?.[0]?.sI;
        const index = selectedBaggages.findIndex(
            item =>
                item.code === baggage.code &&
                item.origin === segments?.[0]?.da?.code &&
                item.destination === segments?.[0]?.aa?.code
        );

        if (index !== -1) {
            const updated = [...selectedBaggages];
            updated.splice(index, 1);
            setSelectedBaggages(updated);
            setTotalAmount(prev => prev - baggage.amount);
        }
        if (bookingFilterRef.current) {
            bookingFilterRef.current.handleRemoveCode();
        }
    };

    const addBaggageReturn = (baggage, flightInfo) => {
        const segments = flightInfo?.[1]?.sI;
        if (selectedBaggagesReturn.length < totalSelectMeals) {
            const newItem = {
                origin: segments?.[0]?.da?.code,
                destination: segments?.[0]?.aa?.code,
                code: baggage.code,
                price: baggage.amount,
                description: baggage.desc,
            };

            setSelectedBaggagesReturn(prev => [...prev, newItem]);
            setTotalAmountBaggageReturn(prev => prev + baggage.amount);
        }
        if (bookingFilterRef.current) {
            bookingFilterRef.current.handleRemoveCode();
        }
    };

    const removeBaggageReturn = (baggage, flightInfo) => {
        const segments = flightInfo?.[1]?.sI;
        const indexToRemove = selectedBaggagesReturn.findIndex(
            item =>
                item.code === baggage.code &&
                item.origin === segments?.[0]?.da?.code &&
                item.destination === segments?.[0]?.aa?.code
        );

        if (indexToRemove !== -1) {
            const newList = [...selectedBaggagesReturn];
            newList.splice(indexToRemove, 1);
            setSelectedBaggagesReturn(newList);
            setTotalAmountBaggageReturn(prev => prev - baggage.amount);
        }
        if (bookingFilterRef.current) {
            bookingFilterRef.current.handleRemoveCode();
        }
    };

    const transformMeals = (dataArray, key) => {
        return (dataArray || [])
            .filter(item => item && item[key])
            .flatMap(({ origin, destination, [key]: mealsArray }) =>
                (mealsArray || []).map(({ code, price, description }) => ({
                    origin,
                    destination,
                    code,
                    price,
                    description
                }))
            );
    };

    const outputMealBaggage = {
        meals: [
            ...transformMeals(selectedMeals, 'selectedMeals'),
            ...transformMeals(selectedMealsReturn, 'selectedMealsReturn'),
        ],
        baggages: [
            ...selectedBaggages,
            ...selectedBaggagesReturn,
        ],
        seats: [
            ...(seatsList || []),
            ...(seatsListReturn || []),
        ],
    };

    const fareDetail = flightDetails?.totalPriceInfo?.totalFareDetail?.fC?.TF || 0;
    const totalBookingPrice = fareDetail + totalAmount + mealTotalAmount + mealTotalAmountRetrun + totalAmountBaggageReturn + totalSeatPrice + totalSeatsPriceReturn;

    const [convenienceCharge, setConvenienceCharge] = useState(null);
    const [convenienceChargeProceed, setConvenienceProceed] = useState(null);
    const [couponId, setCouponId] = useState(null);
    const [applyDiscountShow, setApplyDiscountShow] = useState(false);
    const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
    const [discountAmountOffer, setDiscountAmountOffer] = useState(0);
    const [calculatedFee, setCalculatedFee] = useState(0);
    const [finalTotal, setFinalTotal] = useState(0);
    const [error, setError] = useState(null);
    const [applicableChargeData, setApplicableChargeData] = useState(null);

    const [convenienceChargeTotalFareModal, setConvenienceChargeTotalFareModal] = useState(false);


    const fetchConvenienceCharge = async () => {
        try {
            const params = { type: "charge", category: "flight" };
            const response = await getConvenienceCharge(params);
            setConvenienceCharge(response);
        } catch (err) {
            setError("Failed to fetch convenience charge data");
        }
    };

    useEffect(() => {
        fetchConvenienceCharge();
    }, []);

    useEffect(() => {
        if (convenienceCharge) {
            let calculatedFee = 0;
            let finalTotal = totalBookingPrice;
            const applicableCharge = convenienceCharge.find(
                (charge) =>
                    finalTotal >= charge.min_order_value &&
                    finalTotal <= charge.max_order_value
            );

            if (applicableCharge) {
                setApplicableChargeData(applicableCharge);

                if (applicableCharge.discount_type === "PERCENTAGE") {
                    calculatedFee = (finalTotal * parseFloat(applicableCharge.value)) / 100;
                } else if (applicableCharge.discount_type === "AMOUNT") {
                    calculatedFee = parseFloat(applicableCharge.value);
                }
            }
            finalTotal += calculatedFee;
            setFinalTotal(finalTotal)
            setCalculatedFee(calculatedFee);
        }
    }, [convenienceCharge, selectedMeals, selectedBaggages, flightDetails, selectedMealsReturn, selectedBaggagesReturn]);

    const [collapseCard, setCollapseCard] = useState(true)

    const skipAddonAndPayNow = () => {
        setSelectedMeals([]);
        setSelectedMealsReturn([]);
        setSelectedBaggages([]);
        setSelectedBaggagesReturn([]);
        setMealTotalAmount(0);
        setTotalAmount(0);
        setMealTotalAmountReturn(0);
        setTotalAmountBaggageReturn(0);
        setConvenienceChargeTotalFareModal(true);
        setSeatsListReturn([]);
        setSeatsList([]);
        setSelectedSeats({});
        setSelectedSeatsReturn({});
        setTotalSeatPrice(null);
        setTotalSeatPriceReturn(null);
    };

    const [collapseCardTravellers, setCollapseCardTravellers] = useState(false);



    return (
        <div>
            <section className='result_cntr ptb-30 ptb-md-70'>
                <div className="container">
                    <h2 className='mb-2 mb-md-4'>Review your booking</h2>

                    <Row gutter="20">
                        <Col xl={17} lg={15} xs={24}>
                            <BookingFlightTripJack
                                outputMealBaggage={outputMealBaggage}
                                flightDetails={flightDetails}
                                loading={loading}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                totalBookingPrice={totalBookingPrice}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                selectedMeals={selectedMeals}
                                totalSelectMeals={totalSelectMeals}
                                addMeal={addMeal}
                                removeMeal={removeMeal}
                                selectedMealsReturn={selectedMealsReturn}
                                addMealReturn={addMealReturn}
                                removeMealReturn={removeMealReturn}
                                priceIds={priceIds}
                                convenienceCharge={convenienceCharge}
                                setConvenienceProceed={setConvenienceProceed}
                                applyDiscountShow={applyDiscountShow}
                                applicableChargeData={applicableChargeData}
                                calculatedFee={calculatedFee}
                                finalTotal={finalTotal}
                                setCouponId={setCouponId}
                                couponId={couponId}
                                setApplyDiscountShow={setApplyDiscountShow}
                                discountAmountOffer={discountAmountOffer}
                                setDiscountAmountOffer={setDiscountAmountOffer}
                                totalAfterDiscount={totalAfterDiscount}
                                setTotalAfterDiscount={setTotalAfterDiscount}
                                addBaggageReturn={addBaggageReturn}
                                removeBaggageReturn={removeBaggageReturn}
                                selectedBaggagesReturn={selectedBaggagesReturn}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                totalAmountBaggageReturn={totalAmountBaggageReturn}
                                mealTotalAmount={mealTotalAmount}
                                collapseCard={collapseCard}
                                setCollapseCard={setCollapseCard}
                                setConvenienceChargeTotalFareModal={setConvenienceChargeTotalFareModal}
                                convenienceChargeTotalFareModal={convenienceChargeTotalFareModal}
                                skipAddonAndPayNow={skipAddonAndPayNow}
                                collapseCardTravellers={collapseCardTravellers}
                                setCollapseCardTravellers={setCollapseCardTravellers}
                                setSelectedMeals={setSelectedMeals}
                                setMealTotalAmount={setMealTotalAmount}
                                setSelectedMealsReturn={setSelectedMealsReturn}
                                setMealTotalAmountReturn={setMealTotalAmountReturn}
                                totalSeatPrice={totalSeatPrice}
                                setTotalSeatPrice={setTotalSeatPrice}
                                selectedSeats={selectedSeats}
                                setSelectedSeats={setSelectedSeats}
                                seatsList={seatsList}
                                setSeatsList={setSeatsList}
                                totalSeatsPriceReturn={totalSeatsPriceReturn}
                                setTotalSeatPriceReturn={setTotalSeatPriceReturn}
                                selectedSeatsReturn={selectedSeatsReturn}
                                setSelectedSeatsReturn={setSelectedSeatsReturn}
                                seatsListReturn={seatsListReturn}
                                setSeatsListReturn={setSeatsListReturn}
                                setSelectedBaggages={setSelectedBaggages}
                                setSelectedBaggagesReturn={setSelectedBaggagesReturn}
                                setTotalAmountBaggageReturn={setTotalAmountBaggageReturn}
                                setTotalAmount={setTotalAmount}
                            />
                        </Col>
                        <Col xl={7} lg={9} xs={24} className="d-none d-md-block">
                            <BookingFilterTripjack
                                ref={bookingFilterRef}
                                flightDetails={flightDetails}
                                loading={loading}
                                setSelectedBaggages={setSelectedBaggages}
                                selectedBaggages={selectedBaggages}
                                totalAmount={totalAmount}
                                totalBookingPrice={totalBookingPrice}
                                setTotalAmount={setTotalAmount}
                                addBaggage={addBaggage}
                                removeBaggage={removeBaggage}
                                totalSelectMeals={totalSelectMeals}
                                mealTotalAmount={mealTotalAmount}
                                convenienceCharge={convenienceCharge}
                                setConvenienceProceed={setConvenienceProceed}

                                applyDiscountShow={applyDiscountShow}
                                applicableChargeData={applicableChargeData}
                                calculatedFee={calculatedFee}
                                finalTotal={finalTotal}

                                setCouponId={setCouponId}
                                couponId={couponId}
                                setApplyDiscountShow={setApplyDiscountShow}
                                discountAmountOffer={discountAmountOffer}
                                setDiscountAmountOffer={setDiscountAmountOffer}
                                totalAfterDiscount={totalAfterDiscount}
                                setTotalAfterDiscount={setTotalAfterDiscount}
                                mealTotalAmountRetrun={mealTotalAmountRetrun}
                                totalAmountBaggageReturn={totalAmountBaggageReturn}
                                convenienceChargeTotalFareModal={convenienceChargeTotalFareModal}

                                collapseCardTravellers={collapseCardTravellers}
                                setCollapseCardTravellers={setCollapseCardTravellers}
                                totalSeatPrice={totalSeatPrice}
                                totalSeatsPriceReturn={totalSeatsPriceReturn}
                            />
                        </Col>
                    </Row>

                    <FlightNotFetch
                        messageData={messageData}
                        isModalOpenFlightNotFetch={isModalOpenFlightNotFetch}
                        setIsModalOpenFlightNotFetch={setIsModalOpenFlightNotFetch}
                    />

                    <FareAlertModal alerts={flightDetails?.alerts} />

                </div>
            </section>

        </div>
    )
}

export default BookingDetailsTripJack
